export default [
    {
        code: 'qc',
        transKey: 'COMMONS_FORMS.PROVINCES.QUEBEC',
    },
    {
        code: 'on',
        transKey: 'COMMONS_FORMS.PROVINCES.ONTARIO',
    },
    {
        code: 'ns',
        transKey: 'COMMONS_FORMS.PROVINCES.NOVA_SCOTIA',
    },
    {
        code: 'nb',
        transKey: 'COMMONS_FORMS.PROVINCES.NEW_BRUNSWICK',
    },
    {
        code: 'mb',
        transKey: 'COMMONS_FORMS.PROVINCES.MANITOBA',
    },
    {
        code: 'bc',
        transKey: 'COMMONS_FORMS.PROVINCES.BRITISH_COLUMBIA',
    },
    {
        code: 'pe',
        transKey: 'COMMONS_FORMS.PROVINCES.PRINCE_EDWARD_ISLAND',
    },
    {
        code: 'sk',
        transKey: 'COMMONS_FORMS.PROVINCES.SASKATCHEWAN',
    },
    {
        code: 'ab',
        transKey: 'COMMONS_FORMS.PROVINCES.ALBERTA',
    },
    {
        code: 'nl',
        transKey: 'COMMONS_FORMS.PROVINCES.NEWFOUNDLAND_AND_LABRADOR',
    },
    {
        code: 'nt',
        transKey: 'COMMONS_FORMS.PROVINCES.NORTHWEST_TERRITORIES',
    },
    {
        code: 'yt',
        transKey: 'COMMONS_FORMS.PROVINCES.YUKON',
    },
    {
        code: 'nu',
        transKey: 'COMMONS_FORMS.PROVINCES.NUNAVUT',
    },
];
